import {Sheet, useTheme} from "@mui/joy";
import Grid from "@mui/material/Grid";
import {createFileRoute, useNavigate} from "@tanstack/react-router";
import {ActionButton} from "../../../components/ActionButton.tsx";
import {useTranslation} from "react-i18next";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";

function MastersPage() {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const theme = useTheme();
    const masters = [
        {to: "/admin/agent", label: t("entity.agent")},
        {to: "/admin/waste-flavor", label: t("entity.wasteFlavor")},
        {to: "/admin/downstream-venue", label: t("entity.downstreamVenue")},
        // {to: adminPackingModeRoute.to, label: i18next.t("entity.packingMode")},
        // {to: adminManifestTypeRoute.to, label: i18next.t("entity.manifestType")},
    ];
    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <Sheet sx={{mt: 4}}>
                <Grid container sx={{width: "100%"}}>
                    {masters.map(master =>
                        <Grid size={{xs: 6, md: 4}} key={master.label} sx={{
                            display: "flex",
                            justifyContent: "center",
                            my: 2,
                        }}>
                            <ActionButton
                                size="lg"
                                color="primary"
                                variant="soft"
                                veilSx={{flex: 1, mx: 2, py: 2}}
                                sx={{fontSize: theme.fontSize.xl, py: 2}}
                                perform={() => navigate({to: master.to, params: {}})}>
                                {master.label}
                            </ActionButton>
                        </Grid>)}
                </Grid>
            </Sheet>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/admin/masters")({
    component: MastersPage,
});
